import { call, all, takeLatest, put } from 'redux-saga/effects';
import createFetchFunction from '../utils/create-fetch-func';
import createFetchSagaPattern from '../fetch/fetch-saga-pattern-creator';
import getFetchInstance from './../utils/fetch';
import getDataFromResponse from '../utils/get-data-from-res';
import {
    ICreateQuizPayload,
    IFetchQuizPayload,
    fetchQuizzes,
    fetchQuiz,
    IUpdateQuizPayload,
    IDeleteQuizPayload,
} from './quiz.actions';

function* createQuizAsync({
    payload: { data },
}: {
    payload: ICreateQuizPayload;
}) {
    yield getFetchInstance().post('quiz/insert', data);
}

function* fetchQuizAsync({
    payload: { data },
}: {
    payload: IFetchQuizPayload;
}) {
    const res = yield getFetchInstance().get(`quiz/getQuiz/${data.id}`);
    const quiz = getDataFromResponse(res);
    yield put(
        fetchQuiz({
            quiz,
        })
    );
}

function* fetchQuizzesAsync() {
    const res = yield getFetchInstance().get('quiz/all');
    const quizzes = getDataFromResponse(res);

    yield put(
        fetchQuizzes({
            quizzes,
        })
    );
}

function* updateQuizAsync({
    payload: { data },
}: {
    payload: IUpdateQuizPayload;
}) {
    yield getFetchInstance().post('quiz/update', data);
}

function* deleteQuizAsync({
    payload: { data },
}: {
    payload: IDeleteQuizPayload;
}) {
    yield getFetchInstance().get(`quiz/delete/${data.id}`);
}

function* watchCreateQuiz() {
    yield takeLatest(
        createFetchSagaPattern('CREATE_QUIZ'),
        createFetchFunction('CREATE_QUIZ', createQuizAsync)
    );
}

function* watchFetchQuiz() {
    yield takeLatest(
        createFetchSagaPattern('QUIZ'),
        createFetchFunction('QUIZ', fetchQuizAsync)
    );
}

function* watchFetchQuizzes() {
    yield takeLatest(
        createFetchSagaPattern('QUIZZES'),
        createFetchFunction('QUIZZES', fetchQuizzesAsync)
    );
}

function* watchUpdateQuiz() {
    yield takeLatest(
        createFetchSagaPattern('UPDATE_QUIZ'),
        createFetchFunction('UPDATE_QUIZ', updateQuizAsync)
    );
}

function* watchDeleteQuiz() {
    yield takeLatest(
        createFetchSagaPattern('DELETE_QUIZ'),
        createFetchFunction('DELETE_QUIZ', deleteQuizAsync)
    );
}

export default function* quizSagas() {
    yield all([
        call(watchCreateQuiz),
        call(watchFetchQuiz),
        call(watchFetchQuizzes),
        call(watchUpdateQuiz),
        call(watchDeleteQuiz),
    ]);
}
